var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_11176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0556 8.88873V8.38873H35.5556H4.44445H3.94445V8.88873V22.2221V22.7221H4.44445H35.5556H36.0556V22.2221V8.88873ZM3.94445 31.1109V31.6109H4.44445H35.5556H36.0556V31.1109V26.6665V26.1665H35.5556H4.44445H3.94445V26.6665V31.1109ZM4.44445 7.1665H35.5556C36.0123 7.1665 36.4504 7.34795 36.7734 7.67093C37.0963 7.99391 37.2778 8.43196 37.2778 8.88873V31.1109C37.2778 31.5677 37.0963 32.0058 36.7734 32.3287C36.4504 32.6517 36.0123 32.8332 35.5556 32.8332H4.44445C3.98769 32.8332 3.54964 32.6517 3.22666 32.3287C2.90368 32.0058 2.72223 31.5677 2.72223 31.1109V8.88873C2.72223 8.43196 2.90368 7.99391 3.22666 7.67093C3.54964 7.34795 3.98769 7.1665 4.44445 7.1665Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_11176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnWallet);
export default __webpack_public_path__ + "static/media/BtnWallet.b5f41c0fd750cb47f0ac136bdc9cc70d.svg";
export { ForwardRef as ReactComponent };